import styled from "styled-components";

export const PageSection = styled.section`
  max-width: 780px;
  margin: 0 auto;
  padding: 96px 24px;
  display: grid;
  gap: 24px;

  @media (max-width: 768px) {
    padding: 72px 20px;
  }
`;

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.typography.h1};
  margin: 0;
`;

export const PageSubtitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.muted};
  line-height: 1.6;
`;

export const Paragraph = styled.p`
  margin: 0;
  line-height: 1.7;
`;

export const List = styled.ul`
  margin: 0 0 16px 18px;
  padding: 0;
  line-height: 1.6;
`;
